
export default {
  data() {
    return {
      search: ''
    }
  },
  props: {
    value: {
      type: String,
      default: '',
    }
  },
  methods: {
    setSearchValue(val) {
      this.search = val
    },
    searchMedia() {
      this.$emit('search-media', this.search)
    }
  }
}
